import * as Yup from 'yup';
import { REQUIRED_FIELD } from '../Constants';
import * as Password from '../libs/Password.ts';

const passwordValidator = Yup.string()
  .trim()
  .required(REQUIRED_FIELD)

export default passwordValidator;
